$('.radio label').each((i, v) => {
    $(v).append('<span></span>');
});

$('.checkbox label').each((i, v) => {
    $(v).append('<span></span>');
});

// Floating Label inputs
const searchElements = document.querySelectorAll('.js-search-dropdown');
Array.prototype.forEach.call(searchElements, (el) => {
  const inputEl = el.querySelector('input');
  if (inputEl.value === null || inputEl.value === '') {
    el.classList.add('empty');
  }
  inputEl.addEventListener('focus', () => {
    el.classList.remove('empty');
  });
  inputEl.addEventListener('keypress', () => {
    el.classList.remove('empty');
  });
  inputEl.addEventListener('blur', () => {
    if (inputEl.value === null || inputEl.value === '') {
      el.classList.add('empty');
    }
  });

});

var $recaptchaElement = $('form[data-sc-fxb] .fxt-captcha');
var intervalms = 100;
var executingRecaptcha = false;
var recaptchaVersion = "v2";
var recaptchaSiteKey = "none";

var checkRecaptcha = function () {
    if (executingRecaptcha) { return; }
    if (!window.grecaptcha) { return; }
    var $formElement = $recaptchaElement.closest('form');
    $.validator.unobtrusive.parse($formElement);
    var isFormValid = $formElement.validate().checkForm();
    if (!isFormValid) { return; }

    executingRecaptcha = true;
    window.grecaptcha.ready(function () {
        window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
            $recaptchaElement.val(token);

            executingRecaptcha = false;
            intervalms = 119700; //  just under 2minutes
            clearInterval(interval);
            interval = setInterval(checkRecaptcha, intervalms);
        });
    });
}

if ($recaptchaElement.length) {
    recaptchaVersion = $recaptchaElement.attr("data-recaptcha-version");
    recaptchaSiteKey = $recaptchaElement.attr("data-recaptcha-site-key");

    if (recaptchaVersion == "v3") {
        $recaptchaElement.val("a valid field value, but not a valid captcha token");
        var interval = setInterval(checkRecaptcha, intervalms); // check every 100ms
    } else {
        window.reCaptchaArray = window.reCaptchaArray || [];
        window.reCaptchaArray.push(function () {
            window.grecaptcha.render($recaptchaElement.attr('id') + '_wrapper',
                {
                    'sitekey': recaptchaSiteKey,
                    'callback': function (token) {
                        $recaptchaElement.val(token);
                    },
                    'expired-callback': function (args) {
                        $recaptchaElement.val("");
                    }
                });
        });
    }
};
